import { render, staticRenderFns } from "./Thesis23.vue?vue&type=template&id=4cbe39da&scoped=true&"
import script from "./Thesis23.vue?vue&type=script&lang=js&"
export * from "./Thesis23.vue?vue&type=script&lang=js&"
import style0 from "./Thesis23.vue?vue&type=style&index=0&id=4cbe39da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbe39da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
